module.exports = __webpack_public_path__ + "media/images/home/image0-49e6ee6e73b82ad6e822fc2eeb20e03d.jpeg";